import { render, staticRenderFns } from "./editPost.vue?vue&type=template&id=6704f63c&scoped=true&"
import script from "./editPost.vue?vue&type=script&lang=js&"
export * from "./editPost.vue?vue&type=script&lang=js&"
import style0 from "./editPost.vue?vue&type=style&index=0&id=6704f63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704f63c",
  null
  
)

export default component.exports